import { ChainStakingApi, getHttpClient } from '@capsicum/common';

export const chainStakingApi = getHttpClient.then(client => new ChainStakingApi(client));
